import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@app/core/services/translate.service';
import { GridService } from '../../../grid.service';

@Component({
    selector: 'tt-grid-toggle-state',
    templateUrl: './grid-toggle-state.component.html',
    styleUrls: ['./grid-toggle-state.component.css'],
})
export class GridToggleStateComponent implements OnChanges {
    /**
     * The text to display in the button.
     */
    @Input()
    public ttText: string = '';
    public text = '';

    /**
     * The text to display in the button.
     */
    @Input()
    public ttIcon: string = '';
    public icon = '';

    /**
     * Whether to translate the text to display in the button, default is `'true'`.
     */
    @Input()
    public get ttTranslateText(): boolean {
        return this._translateText;
    }
    public set ttTranslateText(value: BooleanInput | '1' | 1 | 0 | '0') {
        this._translateText = this.customCoerceBoolenProperty(value);
    }
    private _translateText = true;
    /**
     * Whether the button is disabled.
     */
    @Input()
    public get ttDisabled(): boolean | 'hidden' {
        return this._disabled;
    }
    public set ttDisabled(value: BooleanInput | '1' | 1 | 0 | '0' | 'hidden') {
        if (value == 'hidden') {
            this._disabled = 'hidden';
        } else {
            this._disabled = this.customCoerceBoolenProperty(value);
        }
    }
    private _disabled: boolean | 'hidden' = false;

    @Output()
    public ttClick = new EventEmitter<MouseEvent>();

    public buttonClasses: string = 'ag-button ag-floating-filter-button-button tt-grid__toolbar-button';

    constructor(
        public elementRef: ElementRef<HTMLElement>,
        private translate: TranslateService,
        private gridService: GridService,
    ) {}

    public async onClick(event: MouseEvent) {
        this.ttClick.emit(event);
    }

    private async setText() {
        if (this.ttTranslateText && this.ttText) {
            // if (this.buttonConfig!.translate && !!this.buttonConfig!.text) {
            this.text = await this.translate.translate(this.ttText);
        } else {
            this.text = this.ttText ?? '';
        }
    }

    private setIcon() {
        if (!!this.ttIcon) {
            this.icon = this.gridService.getIconClasses(this.ttIcon);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttTranslateText']) {
            this.ttTranslateText = changes['ttTranslateText'].currentValue;
        }

        if (changes['ttDisabled']) {
            this.ttDisabled = changes['ttDisabled'].currentValue;
        }

        if (changes['ttText']) {
            this.setText();
        }

        if (changes['ttIcon']) {
            this.setIcon();
        }
    }

    private customCoerceBoolenProperty(value: any): boolean {
        if (['1', '0', 1, 0, 'true', true, 'false', false].includes(value)) {
            return ['1', 1, true, 'true'].includes(value as any);
        }
        return coerceBooleanProperty(value);
    }
}
